import { useEffect } from 'react';
import apiClient from '../../../../../../services/apiClient';
import { useNavigate, useLocation } from 'react-router-dom';

const PayPalCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const authCode = params.get('code');

    if (authCode) {

      
      apiClient.post(`/paypalauth`, { code: authCode,user_id: JSON.parse(localStorage.getItem('user')).user.id, })
        .then(response => {


          // Handle success, save tokens or update auth state
          navigate('/company-setting/my-company');
         
        })
        .catch(error => {
          console.error('PayPal authentication failed', error);
        });
    }
  }, [location, navigate]);

  return <div>Loading...</div>;
};

export default PayPalCallback;